module.exports = __webpack_public_path__ + "img/logo.b33177f2.svg";